import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useAuth } from '../auth/AuthProvider';
import { getDashboardYears } from '../../controllers/dashboard';
import { getCycleYear } from '../../hooks/useYearParam';

function YearSelector({
  value,
  onChange,
  years,
  label = 'Año',
  keyPrefix = 'year',
  className = 'mb-3',
  colMd = 12
}) {
  const { token } = useAuth();
  const [apiYears, setApiYears] = useState([]);
  const fallbackOptions = Array.from(new Set([value, getCycleYear()].filter(y => Number.isInteger(y))));
  const options = Array.isArray(years) && years.length
    ? years
    : apiYears.length
      ? apiYears
      : fallbackOptions;

  useEffect(() => {
    let isMounted = true;

    if (Array.isArray(years) && years.length) {
      return undefined;
    }

    async function loadYears() {
      try {
        const loadedYears = await getDashboardYears(token);
        if (isMounted && Array.isArray(loadedYears) && loadedYears.length) {
          setApiYears(loadedYears);
        }
      }
      catch (e) {
      }
    }

    if (token) {
      loadYears();
    }

    return () => {
      isMounted = false;
    };
  }, [token, years]);

  return <Row className={className}>
    <Col md={colMd}>
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <Form.Select value={value} onChange={onChange}>
          {options.map(y => <option key={`${keyPrefix}-${y}`} value={y}>{y}</option>)}
        </Form.Select>
      </Form.Group>
    </Col>
  </Row>;
}

export default YearSelector;